import { gql } from "graphql-request";
import { useMutation } from "react-query";
import QueryKeys from "../QueryKeys";
import { gqlClient } from "../../App";

function useDeleteTenant() {
  return useMutation(QueryKeys.DELETE_TENANT, async (input: String) => {
    return await gqlClient.request(
      gql`
        mutation DeleteTenant($input: String!) {
          deleteTenant(id: $input)
        }
      `,
      {
        input,
        operationName: QueryKeys.DELETE_TENANT,
      }
    );
  });
}

export default useDeleteTenant;
